function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "TikTok, Negative",
    clipPath: "url(#clip0_4457_72759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0727 0H13.0281V16.3475C13.0281 18.2953 11.4725 19.8953 9.5366 19.8953C7.60071 19.8953 6.0451 18.2953 6.0451 16.3475C6.0451 14.4345 7.56614 12.8693 9.43291 12.7997V8.69549C5.31914 8.76502 2.00049 12.1389 2.00049 16.3475C2.00049 20.5909 5.38828 23.9995 9.57118 23.9995C13.754 23.9995 17.1418 20.5561 17.1418 16.3475V7.96504C18.6629 9.07808 20.5296 9.73894 22.5001 9.77373V5.66945C19.458 5.56511 17.0727 3.0608 17.0727 0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4457_72759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9995,
    height: 23.9995,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.000488281)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.2b160a3500f23aef0b3f99fd27f9f0a9.svg";
export { ForwardRef as ReactComponent };